export default "__VITE_ASSET__gCm76uxk__"